<template>
<el-dialog class='media-image-dialog' :title="$t('title')" :visible.sync="dialogVisible" @close='close'>
  <el-tabs v-model="currentTag" @tab-click='selected = null; fetchData()'>
    <el-tab-pane class="image-content" :label="$t(`tags.${tag}`)" :name="tag" v-for="tag in tags" :key="tag">
      <p class='no-image' v-show="!images[currentTag] || images[currentTag].length === 0" v-if="!onUploading">{{$t('empty')}}</p>
      <el-radio-group v-model="selected">
        <el-radio class='hide-input' :label="-1" v-if='onUploading' :disabled="true">
          <div class='uploading-progress img cover'>
            <p class='hint'>{{$t('imageUploading')}}</p>
            <el-progress class='uploader-progress-bar' :percentage="progress * 0.8" :show-text="false">
            </el-progress>
          </div>
        </el-radio>
        <el-radio class='hide-input' :label="image.id" v-for="(image, index) in images[currentTag]" :key="image.id">
          <div class='img cover' :style="{'backgroundImage': 'url('+image.file_url+')'}" :class="{'selected': image.id === selected}">
            <i class='ppj-icon-ok'></i>
          </div>
          <el-tooltip effect="light" :content="$t('hint.media.image.remove')" placement="top" :open-delay="500" :popper-options="{removeOnDestroy: true}" v-once>
            <a class='remove-btn' v-on:click.prevent.stop='remove(index)'>
              <i class='ppj-icon-cancel danger'></i>
            </a>
          </el-tooltip>
        </el-radio>
      </el-radio-group>
    </el-tab-pane>
  </el-tabs>

  <div slot="footer" class="dialog-footer">
    <ssuploader class='uploader-btn' :url="uploadUrl" :data="uploadData" name='medium[file]' :extensions="extensions" :progress.sync="progress" :uploading.sync="onUploading" :accept="accept" @complete="uploadComplete" />
    <el-button type='text' @click='close'>{{$t('common.buttons.cancel')}}</el-button>
    <el-button type="primary" @click='save'>{{$t('common.buttons.ok')}}</el-button>
  </div>
</el-dialog>
</template>

<i18n>
{
  "zh-cn": {
    "title": "从素材库选取图片",
    "empty": "暂时没有图片",
    "tags": {
      "thumbnail": "@:common.project封面",
      "cover": "微信分享封面",
      "logo": "企业logo"
    },
    "messagebox": {
      "remove": {
        "title": "从素材库中移除该图片?",
        "message": "注意，该操作不会使之前引用的文件失效"
      },
      "close": {
        "title": "请保持素材库打开",
        "message": "上传文件中，请勿关闭素材库"
      },
      "save": {
        "title": "请选择图片后保存",
        "message": "单击某个图片来选中，或点击取消按钮来关闭素材库"
      }
    },
    "imageUploading": "图片上传中"
  }
}
</i18n>

<script>
import SSUploader from '@/components/widgets/ss_uploader.input'
import lodash from 'lodash'

export default {
  data() {
    return {
      // data stored related
      images: {}, // images: {'tag', [list]}
      currentTag: 'thumbnail',
      initTag: 'thumbnail',
      //   tags: ['thumbnail', 'cover', 'logo'],
      selected: null,
      success: null,
      // ui update related
      dialogVisible: false,
      onUploading: false,
      progress: 0,
      // uploader parameters
      extensions: ['png', 'gif', 'jpeg', 'jpg'],
      accept: '.png, .gif, .jpeg, .jpg, image/*',
      // page related
      currentPage: 1,
      totalPages: 1,
      totalItems: 1,
      pageSize: 1
    }
  },
  components: {
    'ssuploader': SSUploader
  },
  watch: {
    onUploading: function(newValue) {
      if (newValue) {
        this.currentTag = this.initTag
      }
    }
  },
  computed: {
    uploadUrl() {
      let organization = this.$store.getters['user/organization']
      return organization ? `${process.env.API_ROOT}organizations/${organization.id}/media` : `${process.env.API_ROOT}media`
    },
    uploadData() {
      return { 'medium[type]': 'image', 'medium[tag]': this.initTag }
    },
    tags() {
      return this.$store.state.tbcMode ? ['thumbnail', 'cover'] : ['thumbnail', 'cover', 'logo']
    }
  },
  methods: {
    fetchData() {
      let vm = this
      vm.$store.dispatch('media/index', {
        type: 'image',
        tag: vm.currentTag,
        page: vm.currentPage
      }).then(res => {
        let data = res.data
        vm.$set(vm.images, vm.currentTag, data.list || [])
        vm.pageSize = data.page_size
        vm.totalItems = data.total_items
        vm.totalPages = data.total_pages
      })
    },
    open(params = {}) {
      this.success = params.success
      this.initTag = params.initTag || this.initTag
      this.currentTag = this.initTag
      this.fetchData()
      this.dialogVisible = true
    },
    remove(index) {
      let vm = this
      let target = vm.images[vm.currentTag][index]

      vm.$confirm(vm.$t('messagebox.remove.message'), vm.$t('messagebox.remove.title'), {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(_ => {
        vm.$store.dispatch('media/destroy', target.id).then(_ => {
          vm.images[vm.currentTag].splice(index, 1)
        })
      }).catch(_ => {})
    },
    save() {
      let vm = this
      if (!vm.selected) {
        // 未选中图片
        vm.$alert(vm.$t('messagebox.save.message'), vm.$t('messagebox.save.title'), {
          confirmButtonText: vm.$t('common.buttons.ok')
        }).then(_ => {}).catch(_ => {})
      } else {
        let list = vm.images[vm.currentTag]
        let output = JSON.parse(JSON.stringify(list[lodash.findIndex(list, { id: vm.selected })]))
        if (typeof vm.success === 'function') {
          vm.success(output)
        }
        vm.close()
      }
    },
    close() {
      let vm = this

      if (vm.onUploading) {
        // 文件上传中
        vm.$alert(vm.$t('messagebox.close.message'), vm.$t('messagebox.close.title'), {
          confirmButtonText: vm.$t('common.buttons.ok')
        }).then(_ => {}).catch(_ => {})
      } else {
        vm.selected = null
        vm.dialogVisible = false
      }
    },
    uploadComplete(data) {
      this.selected = data.id
      this.images[this.initTag].splice(0, 0, data)
      this.currentTag = this.initTag
    }
  }
}
</script>

<style lang='scss'>
.media-image-dialog {
    // override element default rai
    .el-dialog__body {
        padding-top: $padding-base;
        padding-bottom: $padding-base;
    }
    .el-radio-group {
        display: block;

        .el-radio + .el-radio {
            margin-left: 0;
        }

        .el-radio {
            display: block;
            float: left;
            margin: 0 0.8em 0.8em 0;
        }
    }

    .el-radio.hide-input {
        .el-radio__input {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
        }

        .el-radio__label {
            padding-left: 0;
        }
    }

    .image-content {
        overflow: hidden;
        height: 20em;
        overflow-y: auto;

        .no-image {
            text-align: center;
        }
        .el-radio__input:hover + .el-radio__label {
            .remove-btn {
                visibility: visible;
                opacity: 1;
            }
        }
        .el-radio__input.is-checked:hover + .el-radio__label {
            .remove-btn {
                display: none;
            }
        }
        .remove-btn {
            transition: $all-transition;
            display: block;
            visibility: hidden;
            opacity: 0;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1000;
            &:hover {
                visibility: visible;
                opacity: 1;
            }
        }

        .img {
            height: 9em;
            width: 7em;
            border: $border-base;

            .ppj-icon-ok {
                display: none;
            }

            &.selected {
                border-color: $color-blue-base;
                border-width: $border-width-thick;

                .ppj-icon-ok {
                    display: block;
                    color: #fff;
                    position: absolute;
                    right: 0;
                    z-index: 1;
                    padding-bottom: 0.4em;
                    bottom: 0;
                }

                $arrow-width: 1.5em;
                &:after {
                    content: '';
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 0;
                    height: 0;
                    border-color: transparent;
                    border-style: solid;
                    border-width: $arrow-width;
                    border-bottom-color: $color-blue-base;
                    border-right-color: $color-blue-base;
                }
            }
        }

        .uploading-progress {
            background-color: #fcfcfc;
            text-align: center;
            padding-top: 1.5em;
            .uploader-progress-bar {
                width: 80%;
                margin: 0 auto;
            }
        }
    }

    .dialog-footer {
        .uploader-btn {
            float: left;
        }
    }
}
</style>



// WEBPACK FOOTER //
// image.dialog.vue?68006608